// src/components/Footer.js

import React from 'react'
import { Box, Typography, IconButton } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import XIcon from '@mui/icons-material/X'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import GitHubIcon from '@mui/icons-material/GitHub'

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.default',
        color: 'text.secondary',
        py: 4,
        px: { xs: 2, sm: 4 },
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}
    >
      {/* footer links */}
      <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
        <Typography
          color="text.secondary"
          sx={{ cursor: 'default', textDecoration: 'none' }}
        >
          Documentation
        </Typography>
        <Typography
          component={RouterLink}
          to="/privacy-policy"
          color="text.secondary"
          sx={{ 
            cursor: 'pointer', 
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          Privacy Policy
        </Typography>
        <Typography
          component={RouterLink}
          to="/terms-of-service"
          color="text.secondary"
          sx={{ 
            cursor: 'pointer', 
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' }
          }}
        >
          Terms of Service
        </Typography>
      </Box>

      {/* decorative social icons */}
      <Box>
        <IconButton color="inherit" size="large" sx={{ cursor: 'default' }}>
          <XIcon />
        </IconButton>
        <IconButton color="inherit" size="large" sx={{ cursor: 'default' }}>
          <LinkedInIcon />
        </IconButton>
        <IconButton color="inherit" size="large" sx={{ cursor: 'default' }}>
          <GitHubIcon />
        </IconButton>
      </Box>
    </Box>
  )
}
